import { createEvent, createStore } from 'effector';
import { $resetPanelState } from './balance.entity';

export const $setOnlineClientsCount = createEvent<number>();
export const $onlineClientsCount = createStore<number | null>(null)
	.on($setOnlineClientsCount, (_, count) => count)
	.reset($resetPanelState);
